import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import { deleteFile } from "../../services/delete.service";
import {
  BsFileEarmarkPdfFill,
  BsFileEarmarkImageFill,
  BsEyeFill,
} from "react-icons/bs";
import "../../App.css";
import { jwtDecode } from "jwt-decode";
import "../../styles/modales.css";
import api from "../../services/api";
import { verArchivo } from "../../services/apiService";
import { Table } from "react-bootstrap";

export default function UploadFiles() {
  const token = localStorage.getItem("user");
  const Name = token ? jwtDecode(token).sub : null;

  document.title = "Visualizar Actas Circunstanciadas";

  const [tempost, setTempost] = useState([]);
  const [tempostFiles, setTempostFiles] = useState([]);
  const { id } = useParams();

  const [modalShow, setModalShow] = useState(false);
  const [modalUpload, setModalUpload] = useState(false);
  const [modalUri, setModalUri] = useState(null);
  const [modalUriD, setModalUriD] = useState(null);
  const [error, setError] = useState(null);
  const [errorInput, setErrorInput] = useState(null);

  const [fileData, setFileData] = useState([]);
  // eslint-disable-next-line
  // const [loadingFiles, setLoadingFiles] = useState(true);

  const hasFile = (fileName) => {
    return (
      Array.isArray(fileData) &&
      fileData.some((file) => file.name?.includes(fileName))
    );
  };
  // Obtener los archivos del folio
  const getFilesByFolio = async (folio) => {
    try {
      const response = await api.get(`auth/files/xfolio/${folio}`);
      setFileData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setFileData([]);
    }
  };

  useEffect(() => {
    if (tempost.folio) {
      getFilesByFolio(tempost.folio);
    }
  }, [tempost.folio]);

  const getId = async (event) => {
    try {
      api.get(`acta/${id}`).then((response) => {
        //console.log(response.data);
        setTempost(response.data);
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    getId();
    // eslint-disable-next-line
  }, []);

  const getFiles = async (event) => {
    try {
      api.get(`auth/acta/${id}/files`).then((response) => {
        setTempostFiles(response.data);
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    getFiles();
    // eslint-disable-next-line
  }, []);

  function uploadRespuesta(respuesta) {
    if (respuesta === 1) {
      let res1 = "SI";
      return res1;
    } else if (respuesta === 2) {
      let res2 = "NO";
      return res2;
    } else if (respuesta === 3) {
      let res3 = "N/A";
      return res3;
    }
  }
  ///////////////////////////////////
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async (apartado) => {
    if (!selectedFile) {
      setErrorInput("Por favor, selecciona un archivo antes de subirlo.");
      setTimeout(() => setErrorInput(""), 3000);
      return;
    }

    // Mapeo de apartados a textos específicos
    const textosApartados = {
      dr01: "uri_dr01",
      dr02: "uri_dr02",
      dr03: "uri_dr03",
      dr04: "uri_dr04",
      dr05: "uri_dr05",
      dr06: "uri_dr06",
      dr07: "uri_dr07",
      dr08: "uri_dr08",
      dr09: "uri_dr09",
      dr10: "uri_dr10",
      dr11: "uri_dr11",
      dr12: "uri_dr12",
      dr13: "uri_dr13",
      dr14: "uri_dr14",
      dr15: "uri_dr15",
      dr16: "uri_dr16",
      dr17: "uri_dr17",
      uri_vf01_1: "uri_vf01_1",
      uri_vf01_2: "uri_vf01_2",
      uri_vf01_3: "uri_vf01_3",
      uri_vf01_4: "uri_vf01_4",
      uri_vf01_5: "uri_vf01_5",
      uri_vf02_1: "uri_vf02_1",
      uri_vf02_2: "uri_vf02_2",
      uri_vf02_3: "uri_vf02_3",
      uri_vf03: "uri_vf03",
      uri_vf04: "uri_vf04",
      uri_vf05_1: "uri_vf05_1",
      uri_vf05_2: "uri_vf05_2",
      uri_vf05_3: "uri_vf05_3",
      uri_vf06: "uri_vf06",
      uri_vf07_1: "uri_vf07_1",
      uri_vf07_2: "uri_vf07_2",
      uri_vf08_1: "uri_vf08_1",
      uri_vf08_2: "uri_vf08_2",
      uri_vf09: "uri_vf09",
      uri_vf10: "uri_vf10",
      uri_vf11: "uri_vf11",
      uri_vf12: "uri_vf12",
      uri_vf13: "uri_vf13",
    };

    const textoEspecifico = textosApartados[apartado] || "documento";

    const formData = new FormData();
    formData.append("files", selectedFile);
    formData.append("folio", tempost.folio.toString());
    formData.append("textoEspecifico", textoEspecifico); // Nuevo campo
    formData.append("editado", Name);

    try {
      setIsUploading(true);
      const response = await api.post(
        `auth/upload/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 409) {
        // Conflicto - archivo ya existe
        setErrorInput(response.data.message);
      } else {
        // Mensaje de carga correcta
        setError(response.data.message + "\n  Recargando página espere...");
        getFiles();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 409) {
        setErrorInput(error.response.data.message);
        setTimeout(() => {
          setErrorInput("");
        }, 3000);
      } else {
        setErrorInput(error.response?.data?.message || "Error al subir archivo");
        setTimeout(() => {
          setErrorInput("");
        }, 3000);
      }
    } finally {
      setIsUploading(false);
    }
  };

  // Vista de Archivos
  function MyVerticallyCenteredModal({ uriValue, uriType, ...props }) {
    // eslint-disable-next-line
    const [isDeleting, setIsDeleting] = useState(false);
    // eslint-disable-next-line
    const [deleteError, setDeleteError] = useState(null);
    // eslint-disable-next-line
    const handleDelete = async (filename) => {
      if (
        !window.confirm("¿Estás seguro de que deseas eliminar este archivo?")
      ) {
        return;
      }

      setIsDeleting(true);
      setDeleteError(null);

      try {
        await deleteFile(filename);
        window.location.reload();
      } catch (error) {
        setDeleteError(error.message || "Error al eliminar el archivo");
      } finally {
        setIsDeleting(false);
      }
    };
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#343a40", color: "white" }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <BsFileEarmarkPdfFill /> Documento(s) Descarga: {uriValue}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Acciones</th>
                <th scope="col">Detalle del Archivo</th>
              </tr>
            </thead>
            <tbody>
              {tempostFiles?.map((archivo) => {
                // Extraemos el nombre base sin extensión
                const fileNameWithoutExt = archivo.name
                  .split(".")
                  .slice(0, -1)
                  .join(".");
                const expectedName = `${tempost.id}_${archivo.folio}_${uriValue?.split(".")[0]}`;

                return (
                  fileNameWithoutExt === expectedName && (
                    <tr key={archivo.id}>
                      <td>
                        {fileData
                          .filter((file) => file.id === archivo.id)
                          .map((file) => (
                            <div key={file.id}>
                              <Button
                                className="btn btn-light"
                                onClick={() => verArchivo(file.name)}
                              >
                                <BsEyeFill /> Ver
                              </Button>
                              <br />
                              {/* <br />
                              <Button
                                className="btn btn-light"
                                onClick={() => handleDelete(file.name)}
                                
                              >
                                <BsEyeFill /> Eliminar               
                              </Button> */}
                            </div>
                          ))}
                      </td>

                      <td>
                        {/* Filtrar fileData para mostrar solo los datos del archivo actual
                        evalua la columna id de la tabla id, misma que ya trae en la búsqueda del archivo para el modal
                        por la urivalue que le enviamos al modal por medio de la variable */}
                        {fileData
                          .filter((file) => file.id === archivo.id) // Comparar con el id del archivo actual
                          .map((file) => (
                            <b key={file.id}>
                              <p>Nombre: {file.name}</p>
                              <p>Folio: {file.folio}</p>
                              <p>Cargado por: {file.editado}</p>
                              <p>Fecha: {file.date}</p>
                            </b>
                          ))}
                      </td>

                    </tr>
                  )
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Carga de Archivos
  function MyVerticallyCenteredModalUpload({ uriValueD, uriType, ...props }) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#343a40", color: "white" }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <BsFileEarmarkPdfFill /> <BsFileEarmarkImageFill /> Documento(s)
            Carga: {uriValueD}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Archivo(s)</th>
                <th scope="col">{uriType}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    onChange={(e) => {
                      e.stopPropagation();
                      handleFileUpload(e);
                    }}
                  />
                  {selectedFile && (
                    <p>Archivo seleccionado: {selectedFile.name}</p>
                  )}
                </td>
                <td></td>
              </tr>
              <br />
              {errorInput && (
                <div className="alert alert-danger" role="alert">
                  {errorInput}
                </div>
              )}
              {error && (
                <div className="alert alert-success" role="alert">
                  {error}
                </div>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              resetUploadForm();
              props.onHide();
            }}
          >
            Cerrar
          </Button>
          <Button
            onClick={() => handleUpload(uriValueD)}
            disabled={isUploading}
          >
            {isUploading ? "Subiendo..." : "Subir Archivo"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const resetUploadForm = () => {
    setSelectedFile(null);
    setError("");
    setModalUriD(null);
    setModalUri(null);
  };


  return (
    <div className="flex">
      <Sidebar />
      <div className="content-center w-100">
        <Navbar />
        <div>
          <br></br>
          <br></br>
          <div className="actaviewup">
            <div className="form-group">
              <h4 className="text-center">
                <strong>Visualizar Expediente</strong>
              </h4>
            </div>
            <br></br>
            <div className="list row justify-content-center">
              <div className="col-md-12">
                <Table
                  size="sm"
                  responsive
                  className="tablecursos text-center"
                >
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">NÚM</th>
                      <th scope="col">CUMPLE</th>
                      <th scope="col">DOCUMENTACIÓN REQUERIDA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      <tr /*1*/>
                        <td>{1}</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr1?.id)}</p>

                          {tempost?.respuesta_dr1?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr01.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>

                            </>
                          ) : tempost?.respuesta_dr1?.id === 2 ? (
                            <>
                              {hasFile("uri_dr01") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr01.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>

                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr01");
                                    setModalUpload(true)
                                  }}

                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen Técnico de Riesgo por Uso de Suelo en
                            Materia de Protección Civil. Art. 85 y 88 de la Ley
                            Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*3*/>
                        <td>{2}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr3?.id)}</p>
                          {tempost?.respuesta_dr3?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr03.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr3?.id === 2 ? (
                            <>
                              {hasFile("uri_dr03") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr03.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr03");
                                    setModalUpload(true)
                                  }}

                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen Estructural, elaborado por una persona
                            especialista en la materia (Arquitectura o
                            Ingeniería Civil) con Cédula Profesional y registro
                            vigente que lo acredite como la o el Perito
                            Responsable de Obra. Artículo 83, fracción IX la Ley
                            Número 856, y con apoyo en el artículo 87 de la Ley
                            que Regula las Construcciones Públicas y Privadas
                            del Estado de Veracruz de Ignacio de la Llave, así
                            como de los artículos 36, 37 fracción II, 38
                            fracción IV y 239 de su Reglamento.
                          </p>
                        </td>
                      </tr>
                      <tr /*4*/>
                        <td >{3}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr4?.id)}</p>
                          {tempost?.respuesta_dr4?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr04.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr4?.id === 2 ? (
                            <>
                              {hasFile("uri_dr04") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr04.pdf");
                                      setModalShow(true)
                                    }}

                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr04");
                                    setModalUpload(true)
                                  }}

                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen de Verificación de las Instalaciones
                            Eléctricas, elaborado por una Unidad de Verificación
                            aprobado por la Secretaría de Energía mediante firma
                            digital. Artículo 83, fracción IX de la Ley Número
                            856.
                          </p>
                        </td>
                      </tr>
                      <tr /*5*/>
                        <td >{4}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr5?.id)}</p>
                          {tempost?.respuesta_dr5?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr05.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>

                            </>
                          ) : tempost?.respuesta_dr5?.id === 2 ? (
                            <>
                              {hasFile("uri_dr05") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr05.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr05");
                                    setModalUpload(true)
                                  }}

                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Póliza de seguro, especificando vigencia y que
                            ampare los daños que su actividad ocasione a
                            terceros en sus bienes y personas, medio ambiente,
                            vías de comunicación urbana y servicios
                            estratégicos. Artículo 73 de la Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*6*/>
                        <td >{5}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr6?.id)}</p>
                          {tempost?.respuesta_dr6?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr06.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>

                            </>
                          ) : tempost?.respuesta_dr6?.id === 2 ? (
                            <>
                              {hasFile("uri_dr06") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr06.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr06");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr06"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Copia simple del Acta Constitutiva de la empresa.
                            Artículo 27 del Código de Procedimientos
                            Administrativos para el Estado de Veracruz de
                            Ignacio de la Llave.
                          </p>
                        </td>
                      </tr>
                      <tr /*7*/>
                        <td>{6}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr7?.id)}</p>
                          {tempost?.respuesta_dr7?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr07.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr7?.id === 2 ? (
                            <>
                              {hasFile("uri_dr07") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr07");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr07"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <td>
                            <p>
                              {" "}
                              Permiso de funcionamiento emitido por la Comisión
                              Reguladora de Energía. De conformidad con lo
                              estipulado en los Artículos 48 y 49 de la Ley de
                              Hidrocarburos, Estaciones de Autoconsumo lo
                              señalado en los criterios ASEA-CRT-003-2019.
                            </p>
                          </td>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>CRE 01</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_01");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>

                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_01") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_01");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>

                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 02</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_02");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>

                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_02") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_02");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>

                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 03</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_03");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_03") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_03");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 04</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_04");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_04") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_04");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 05</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_05");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_05") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_05");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 06</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_06");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_06") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_06");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 07</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_07");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_07") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_07");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>CRE 08</strong>
                              </p>
                              {tempost?.respuesta_dr7?.id === 1 ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr07cre_08");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : tempost?.respuesta_dr7?.id === 2 ? (
                                <>
                                  {hasFile("cre_08") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_dr07cre_08");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : null}
                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                    </>
                  </tbody>
                </Table>
                <Table
                  size="sm"
                  responsive
                  className="tablecursos text-center"
                >
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">NÚM</th>
                      <th scope="col">CUMPLE</th>
                      <th scope="col">DOCUMENTACIÓN REQUERIDA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      <tr /*2*/>
                        <td >{7}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr2?.id)}</p>
                          {tempost?.respuesta_dr2?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr02.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr2?.id === 2 ? (
                            <>
                              {hasFile("uri_dr02") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr02.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr02");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr02"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Programa de capacitación en materia de protección
                            civil y evidencias actualizadas. Artículo 66 inciso
                            G de la Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*8*/>
                        <td >{8}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr8?.id)}</p>
                          {tempost?.respuesta_dr8?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr08.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr8?.id === 2 ? (
                            <>
                              {hasFile("uri_dr08") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr08.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>

                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr08");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr08"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen de Operación y Mantenimiento de Estaciones
                            de Servicio de la NOM-005-ASEA-2016, emitido por una
                            Unidad de Verificación ante la Agencia de Seguridad,
                            Energía y Ambiente - ASEA. Artículo 83 fracción IX
                            de la Ley 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*9*/>
                        <td >{9}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr9?.id)}</p>
                          {tempost?.respuesta_dr9?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr09.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr9?.id === 2 ? (
                            <>
                              {hasFile("uri_dr09") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr09.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr09");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr09"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Pruebas de hermeticidad a los tanques y tuberías de
                            la Estación de Servicio de conformidad con lo
                            establecido en la NOM-005-ASEA-2016, Diseño,
                            construcción, operación y mantenimiento de
                            Estaciones de Servicio para almacenamiento y
                            expendio de diésel y gasolinas.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr /*10*/>
                        <td >{10}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr10?.id)}</p>
                          {tempost?.respuesta_dr10?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr10.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr10?.id === 2 ? (
                            <>
                              {hasFile("uri_dr10") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr10.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr10");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr10"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            NOM-020-STPS-2011, Recipientes sujetos a presión,
                            recipientes criogénicos y generadores de vapor o
                            calderas - Funcionamiento - Condiciones de Seguridad
                          </p>
                        </td>
                      </tr>
                      <tr /*11*/>
                        <td >{11}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr11?.id)}</p>
                          {tempost?.respuesta_dr11?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr11.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr11?.id === 2 ? (
                            <>
                              {hasFile("uri_dr11") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr11.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr11");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr11"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Manifiesto de recolección de residuos peligrosos.
                            Artículos del 82 al 84 del Reglamento de la Ley
                            General para la Prevención y Gestión Integral de los
                            Residuos, y el artículo 83 de fracción X de la Ley
                            856.
                          </p>
                        </td>
                      </tr>
                      <tr /*12*/>
                        <td >{12}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr12?.id)}</p>
                          {tempost?.respuesta_dr12?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr12.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr12?.id === 2 ? (
                            <>
                              {hasFile("uri_dr12") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr12.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr12");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr12"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Bitácora de mantenimiento de extintores y detectores
                            de humo. Numeral 7.4 de la NOM-002-STPS-2010,
                            Condiciones de Seguridad, Prevención y Protección
                            Contra Incendios en los Centros de Trabajo; y el
                            artículo 66 fracción IV inciso h de la Ley 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*13*/>
                        <td >{13}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr13?.id)}</p>
                          {tempost?.respuesta_dr13?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr13.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr13?.id === 2 ? (
                            <>
                              {hasFile("uri_dr13") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr13.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr13");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr13"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Bitácora de mantenimiento eléctrico. Numeral 7.5 y
                            7.7 de la NOM-002-STPS-2010. Condiciones de
                            Seguridad, Prevención y Protección contra incendios
                            en los centros de trabajo y el artículo 66 fracción
                            IV inciso h de la Ley 856.
                          </p>
                        </td>
                      </tr>
                      <tr /*14*/>
                        <td >{14}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr14?.id)}</p>
                          {tempost?.respuesta_dr14?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr14.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr14?.id === 2 ? (
                            <>
                              {hasFile("uri_dr14") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr14.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr14");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr14"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Bitácora de simulacros que incluya evidencia de la
                            realización de los mismos por lo menos cada seis
                            meses. Artículo 72 de la Ley Número 856, así como el
                            Artículo 31 fracción II inciso G de su Reglamento.
                          </p>
                        </td>
                      </tr>
                      <tr /*15*/>
                        <td >{15}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr15?.id)}</p>
                          {tempost?.respuesta_dr15?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr15.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr15?.id === 2 ? (
                            <>
                              {hasFile("uri_dr15") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr15.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr15");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr15"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen de Verificación de las Instalaciones de Gas
                            L.P. o Natural (según aplique), elaborado por una
                            Unidad de Verificación, aprobado por la Secretaría
                            de Energía. Artículo 70 de la Ley Número 856.{" "}
                          </p>
                        </td>
                      </tr>
                      <tr /*16*/>
                        <td >{16}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr16?.id)}</p>
                          {tempost?.respuesta_dr16?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr16.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr16?.id === 2 ? (
                            <>
                              {hasFile("uri_dr16") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr16.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr16");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr16"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Dictamen correspondiente de acuerdo a la
                            NOM-013-SEDG-2002, en el caso que el recipiente no
                            portátil de almacenamiento de Gas L.P. tenga diez
                            años de fabricación (posteriormente cada cinco
                            años), cuando el área de la sección cilíndrica o
                            casquetes haya sido reparada con cambio de placa y
                            cuando el recipiente haya estado expuesto al fuego.
                          </p>
                        </td>
                      </tr>
                      <tr /*17*/>
                        <td >{17}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_dr17?.id)}</p>
                          {tempost?.respuesta_dr17?.id === 1 ? (
                            <>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => {
                                  setModalUri("uri_dr17.pdf");
                                  setModalShow(true)
                                }}
                              >
                                Detalle
                              </Button>
                            </>
                          ) : tempost?.respuesta_dr17?.id === 2 ? (
                            <>
                              {hasFile("uri_dr17") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_dr17.pdf");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => {
                                    setModalUriD("dr17");
                                    setModalUpload(true)
                                  }}
                                  uriValueD="dr17"
                                >
                                  Cargar
                                </Button>
                              )}
                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>Otros: {tempost.respuesta_dr17_preg}</p>
                        </td>
                      </tr>
                    </>
                  </tbody>

                </Table>

              </div>

            </div>
            <br></br>
            <div className="list row justify-content-center">
              <div className="col-md-12">
                <Table
                  size="sm"
                  responsive
                  className="tablecursos text-center"
                >
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">NÚM</th>
                      <th scope="col" width="100px">
                        CUMPLE
                      </th>
                      <th scope="col">VERIFICACIÓN FÍSICA-REQUERIMIENTOS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      <tr>
                        <td >{"R" + 1}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr1?.id)}</p>
                        </td>
                        <td>
                          <p>
                            Señalización en materia de protección civil en las
                            áreas que lo requieran, las cuales deben incluir,
                            rutas de evacuación, punto de reunión, zonas seguras
                            NOM-003-SEGOB-2011, Señales y avisos para protección
                            civil. Colores, formas y símbolos a utilizar.
                            Artículo 83, fracción I de la Ley Número 856.
                          </p>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>Rutas de evacuación</strong>
                              </p>

                              {tempost.respuesta_vfr1_1 === true ? (
                                <>
                                  <b>SI &ensp;</b>

                                  {hasFile("uri_vf01_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr1_1 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf01_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Punto de reunión</strong>
                              </p>
                              {tempost.respuesta_vfr1_2 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf01_2") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_2.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr1_2 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf01_2") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf01_2.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Zonas seguras</strong>
                              </p>
                              {tempost.respuesta_vfr1_3 === true ? (
                                <>
                                  <b>SI &ensp;</b>

                                  {hasFile("uri_vf01_3") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_3.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr1_3 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf01_3") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf01_3.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Riesgo eléctrico</strong>
                              </p>
                              {tempost.respuesta_vfr1_4 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf01_4") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_4.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr1_4 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf01_4") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf01_4.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Suficiente señalización</strong>
                              </p>
                              {tempost.respuesta_vfr1_5 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf01_5") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf01_5.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr1_5 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf01_5") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf01_5.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 2}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr2?.id)}</p>
                        </td>
                        <td>
                          <p>
                            Contar con salidas de emergencia, conforme al
                            numeral 7.16 de la NOM-002-STPS-2010, Condiciones de
                            seguridad-prevención y protección contra incendios
                            en los centros de trabajo, así como el artículo 63
                            de la Ley Número 856.
                          </p>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>Señalizadas</strong>
                              </p>
                              {tempost.respuesta_vfr2_1 === true ? (
                                <>
                                  <b>SI &ensp;</b>

                                  {hasFile("uri_vf02_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf02_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr2_1 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf02_1") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf02_1.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Sin obstáculos</strong>
                              </p>
                              {tempost.respuesta_vfr2_2 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf02_2") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf02_2.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr2_2 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf02_2") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf02_2.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Sistema de iluminación</strong>
                              </p>
                              {tempost.respuesta_vfr2_3 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf02_3") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf02_3.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr2_3 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf02_3") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf02_3.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 3}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr3?.id)}</p>

                          {tempost?.respuesta_vfr3?.id === 1 ? (
                            <>
                            
                              {hasFile("uri_vf03") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf03.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr3?.id === 2 ? (
                            <>
                              {hasFile("uri_vf03") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf03.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Señalización en los desniveles de los escalones y
                            cambios de nivel del inmueble, así como pisos llanos
                            en las zonas de tránsito de personas. Numerales 7.4
                            y 7.5 de la NOM-001-STPS-2008, Edificios, locales,
                            instalaciones y áreas en los centros de
                            trabajo-Condiciones de seguridad. Artículo 83
                            fracción X de la Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 4}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr4?.id)}</p>
                          {tempost?.respuesta_vfr4?.id === 1 ? (
                            <>
                              {hasFile("uri_vf04") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf04.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr4?.id === 2 ? (
                            <>
                              {hasFile("uri_vf04") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf04.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Colocación de pictogramas en los recipientes de
                            almacenamiento. NOM-018-STPS-2015 Sistema armonizado
                            para la identificación y comunicación de riesgos por
                            sustancias químicas peligrosas. Artículo 83
                            fracciones II, IV y V de la Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 5}&ensp;</td>
                        <p>{uploadRespuesta(tempost?.respuesta_vfr5?.id)}</p>

                        <td>
                          <p>
                            Señalización en el área específica para el depósito
                            de sustancias químicas, de acuerdo al artículo 83 de
                            la Ley Número 856.
                          </p>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>Resguardadas</strong>
                              </p>
                              {tempost.respuesta_vfr5_1 === true ? (
                                <>
                                  <b>SI &ensp;</b>

                                  {hasFile("uri_vf05_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf05_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr5_1 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf05_1") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf05_1.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Identificadas</strong>
                              </p>
                              {tempost.respuesta_vfr5_2 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf05_2") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf05_2.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}

                                </>
                              ) : tempost.respuesta_vfr5_2 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf05_2") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf05_2.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Ventiladas</strong>
                              </p>
                              {tempost.respuesta_vfr5_3 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf05_3") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf05_3.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}

                                </>
                              ) : tempost.respuesta_vfr5_3 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf05_3") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf05_3.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 6}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr6?.id)}</p>
                          {tempost?.respuesta_vfr6?.id === 1 ? (
                            <>
                              {hasFile("uri_vf06") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf06.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr6?.id === 2 ? (
                            <>
                              {hasFile("uri_vf06") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf06.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Croquis, plano o mapa general del inmueble, con lo
                            señalado en el numeral 5.2 de la NOM-002-STPS-2010,
                            Condiciones de Seguridad – Prevención y Protección
                            Contra Incendios en los Centros de Trabajo.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 7}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr7?.id)}</p>
                        </td>
                        <td>
                          <p>
                            Instalaciones eléctricas - condición física, de
                            acuerdo con la NOM-002-STPS-2010. Condiciones de
                            seguridad-prevención y protección contra incendios
                            en los centros de trabajo, en sus numerales 7.5 y
                            7.5.2
                          </p>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>
                                  Evitan uso de extensiones o tabletas multi
                                  contacto
                                </strong>
                              </p>
                              {tempost.respuesta_vfr7_1 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf07_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf07_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr7_1 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf07_1") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf07_1.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>Evitan improvisaciones</strong>
                              </p>
                              {tempost.respuesta_vfr7_2 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf07_2") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf07_2.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr7_2 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf07_2") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf07_2.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 8}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr8?.id)}</p>
                        </td>
                        <td>
                          <p>
                            Instalaciones de Gas L. P., de acuerdo a la
                            NOM-004-SEDG-2004, Instalaciones de aprovechamiento
                            de Gas L.P., diseño y construcción.
                          </p>
                          <table
                            class="table table-sm text-center"
                            style={{ margin: 50 }}
                            responsive
                          >
                            <td>
                              <p>
                                <strong>Identificación de tuberías</strong>
                              </p>
                              {tempost.respuesta_vfr8_1 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf08_1") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf08_1.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr8_1 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf08_1") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf08_1.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                            <td>
                              <p>
                                <strong>
                                  Cumple con recipiente NO mayor a 10 años de
                                  fabricación (no portátil)
                                </strong>
                              </p>
                              {tempost.respuesta_vfr8_2 === true ? (
                                <>
                                  <b>SI &ensp;</b>
                                  {hasFile("uri_vf08_2") ? (
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => {
                                        setModalUri("uri_vf08_2.jpeg");
                                        setModalShow(true);
                                      }}
                                    >
                                      Detalle
                                    </Button>
                                  ) : (
                                    <b>(Sin Evidencia)</b>
                                  )}
                                </>
                              ) : tempost.respuesta_vfr8_2 === false ? (
                                <>
                                  <b>NO &ensp;</b>

                                  {hasFile("uri_vf08_2") ? (
                                    <>
                                      <Button
                                        variant="success"
                                        size="sm"
                                        onClick={() => {
                                          setModalUri("uri_vf08_2.jpeg");
                                          setModalShow(true)
                                        }}
                                      >
                                        Detalle
                                      </Button>
                                    </>
                                  ) : <b>(Sin Evidencia)</b>}

                                </>
                              ) : null}
                            </td>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 9}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr9?.id)}</p>
                          {tempost?.respuesta_vfr9?.id === 1 ? (
                            <>
                              {hasFile("uri_vf09") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf09.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr9?.id === 2 ? (
                            <>
                              {hasFile("uri_vf09") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf09.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Extintores vigentes y señalizados para permitir su
                            rápida localización, ubicados en lugares despejados
                            de obstáculos que impidan o dificulten su uso y a
                            una altura no mayor a 1.50 m, en especial donde
                            almacenen o utilicen material combustible e
                            inflamable. La cantidad y tipo serán conforme la
                            clasificación de riesgo de incendio, de acuerdo a lo
                            establecido en los numerales 5.10, 7.14, 7.17, 7.18,
                            7.19 y 7.4, de la NOM-002-STPS-2010, Condiciones de
                            seguridad-Prevención y protección contra incendios
                            en los centros de trabajo, y al artículo 83 de la
                            Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 10}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr10?.id)}</p>
                          {tempost?.respuesta_vfr10?.id === 1 ? (
                            <>
                              {hasFile("uri_vf10") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf10.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr10?.id === 2 ? (
                            <>
                              {hasFile("uri_vf10") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf10.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Detectores de humo, en especial donde almacenen o
                            utilicen material combustible e inflamable. La
                            cantidad y tipo serán conforme la clasificación de
                            riesgo de incendio, de acuerdo a lo establecido en
                            los numerales 5.10, 7.14 y 7.4 (además, considerar
                            la Guía de Referencia IV: Detectores de Incendios),
                            de la NOM-002-STPS-2010, Condiciones de
                            seguridad-Prevención y protección contra incendios
                            en los centros de trabajo, y al artículo 83 de la
                            Ley Número 856.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 11}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr11?.id)}</p>
                          {tempost?.respuesta_vfr11?.id === 1 ? (
                            <>
                              {hasFile("uri_vf11") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf11.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr11?.id === 2 ? (
                            <>
                              {hasFile("uri_vf11") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf11.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Aseguramiento de estantes a pisos o muros, con el
                            fin de evitar su caída en caso de sismo, para que no
                            causen lesiones a las personas usuarias y no se
                            obstaculice la ruta de evacuación. Numeral 5.1, 5.2
                            y 5.3 de la NOM-001-STPS-2008.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 12}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr12?.id)}</p>
                          {tempost?.respuesta_vfr12?.id === 1 ? (
                            <>
                              {hasFile("uri_vf12") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf12.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr12?.id === 2 ? (
                            <>
                              {hasFile("uri_vf12") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf12.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Botiquines de primeros auxilios en lugares visibles,
                            abastecidos con material en buenas condiciones, de
                            conformidad con el numeral II.2.3.3 de la Guía de
                            Referencia II de la NOM-030-STPS-2009, Servicios
                            preventivos de seguridad y salud en el
                            trabajo-Funciones y actividades.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td >{"R" + 13}&ensp;</td>
                        <td>
                          <p>{uploadRespuesta(tempost?.respuesta_vfr13?.id)}</p>
                          {tempost?.respuesta_vfr13?.id === 1 ? (
                            <>
                              {hasFile("uri_vf13") ? (
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => {
                                    setModalUri("uri_vf13.jpeg");
                                    setModalShow(true);
                                  }}
                                >
                                  Detalle
                                </Button>
                              ) : (
                                <b>(Sin Evidencia)</b>
                              )}
                            </>
                          ) : tempost?.respuesta_vfr13?.id === 2 ? (
                            <>
                              {hasFile("uri_vf13") ? (
                                <>
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => {
                                      setModalUri("uri_vf13.jpeg");
                                      setModalShow(true)
                                    }}
                                  >
                                    Detalle
                                  </Button>
                                </>
                              ) : <b>(Sin Evidencia)</b>}

                            </>
                          ) : null}
                        </td>
                        <td>
                          <p>
                            Orden y limpieza permanentes en las áreas de
                            trabajo, según lo señalan los numerales 5.1 y 7.1.1
                            de la NOM-001-STPS-2008, Edificios, locales,
                            instalaciones y áreas en los centros de
                            trabajo-Condiciones de seguridad. Artículo 83
                            fracción X de la Ley Número 856.
                          </p>
                        </td>
                      </tr>
                    </>
                  </tbody>

                </Table>
              </div>
            </div>
          </div>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => {
              setModalShow(false);
              setModalUri(null);
            }}
            uriValue={modalUri}
          />
          <MyVerticallyCenteredModalUpload
            show={modalUpload}
            onHide={() => {
              setModalUpload(false);
              setModalUriD(null);
            }}
            uriValueD={modalUriD}
          />
          <br></br>
          <br></br>
        </div>
      </div>
    </div >
  );
}
